import { render, staticRenderFns } from "./IntegrationLinkCheckbox.vue?vue&type=template&id=4552f4d1&scoped=true"
import script from "./IntegrationLinkCheckbox.vue?vue&type=script&lang=js"
export * from "./IntegrationLinkCheckbox.vue?vue&type=script&lang=js"
import style0 from "./IntegrationLinkCheckbox.vue?vue&type=style&index=0&id=4552f4d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4552f4d1",
  null
  
)

export default component.exports